import React from "react";
import Client from "../../../../shared/entities/Client";

const ClientContext = React.createContext<Client|null>(null);

export default ClientContext;
